<script>
import Vue from "vue";

export default Vue.extend({
    name: "array-table-field-items",
    props: {
        row: {
            required: false,
            default: null,
        },
        field: {
            required: true,
        },
        index: {
            required: false,
            default: null
        },
        datatable: {
            required: false,
            default: null
        },
        store: {
            required: false,
            default: null
        },
    },
    mounted() {
    }
})
</script>

<template>
    <div>
        <div
            v-for="(value, key) in field"
            :key="key"
        >
            <array-table-field-items
                v-if="typeof value === 'object' && !Array.isArray(value)"
                :datatable="datatable"
                :index="key"
                :field="value"
            ></array-table-field-items>
            <div v-else>
                <div>
                    <table class="table table-bordered">
                        <tr v-if="Array.isArray(value)">
                            <td class="table-info">{{ key }}</td>
                            <td v-for="item in value">{{ item }}</td>
                        </tr>
                        <tr v-else>
                            <td v-text="key" class="table-info"></td>
                            <td v-text="value"></td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>

</style>